import React, { cloneElement, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TableColumn, TableSettings } from "../../../../tableSettings";
import periodCloseIcon from '../../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../../img/periodclose-12.svg';
import AbstractListView, {
  DataFetchResult, ExportRowRenderer, ListCustomFilterRenderer,
  ListOrderBy, ListRowRenderer
} from "../../../common/AbstractListView";
import constants from '../../../../constants';
import { Search } from "../../../../filtering";
import { NavigationType, openNewPage } from '../../../../util/navigationHelpers';
import {
  CurrencyAmountRenderer, DateRenderer, DateTimeRenderer,
  NullableCheckboxIconRenderer, TextAlignLeftRenderer, TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import useReportViewer from '../../../../hooks/useReportViewer';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import { JobNames } from "../../../../framework.core/JobNames";
import { DocumentType } from "../../../../framework.core/DocumentType";
import { allPaymentList } from "../../tableSettings";
import { AllPaymentListItem } from "../../../../fms.data/models/AllPaymentListItem";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import HistoryViewPayment from '../../../reports/HistoryViewPayment';
import IfmsModal from '../../../../ui/IfmsModal';
import { FmsSubMenu } from '../../../../constants/fmsSubMenu';
import { FmsSecTask } from '../../../../fms.core/constants';
import { CheckSubArgs } from '../../../../fms.report/args';
import { findSecurityTask, getSecBySecTask } from '../../../../util';
import { useJournal } from '../../general/journal/JournalListView';
import { formatDate, nowDate } from '../../../../dateUtils';
import CustomerBalanceDetails from '../../../reports/AccountBalance';
import { SecType } from '../../../../fms.enum';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../../common/commonExportFormat';
import CheckBoxIcon from '../../../../ui/CheckBoxIcon';
import IconButton, { BalanceIconButton, DeleteHistoryIconButton, JournalIconButton, PrintIconButton, ViewHistoryIconButton, ViewIconButton, ViewIconButton2 } from '../../../../ui/IconButton';
import CheckPrint from '../../../reports/CheckPrint';
import { SearchModelBase } from '../../../../fms.data/models/SearchModelBase';

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  // function onIndicatorClick() {
  //   if (jobListContext.rowExtrasId) {
  //     return; // Some row is already selected
  //   }

  //   jobListContext.setRowExtrasId(data[row.index].id);
  // }

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function VoidRenderer({ cell, data, row }: any) {
  const l = data[row.index];
  let dataTooltip = formatDate((l as any).voidDate);

  if (cell && cell.value) {
    return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={dataTooltip}>
      <CheckBoxIcon value={true} />
    </div>;
  }

  return <div className="ifms-table-default ifms-check-box-icon-false" id={`${cell.column.id}-${cell.row.index}`}></div>;
}

function TypeRenderer({ cell, data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lPayment = (l as any).payment as string;
  if (lPayment === 'C') dataTooltip = 'CHECK';
  else if (lPayment === 'W') dataTooltip = 'W/T';
  else if (lPayment === 'A') dataTooltip = 'ACH';
  else if (lPayment === 'O') dataTooltip = 'OTHER';
  else if (lPayment === 'OF') dataTooltip = 'OFFSET';
  else if (lPayment === 'CC') dataTooltip = 'Credit Card';

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ textAlign: 'center' }}>{cell.value}</div>
  );
}

function PaymentTypeRenderer({ cell, data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lPayment = (l as any).paymentType as string;
  if (lPayment === 'CUST') dataTooltip = 'Customer Pay';
  else if (lPayment === 'CC') dataTooltip = 'CC Pay';
  else if (lPayment === 'BILL') dataTooltip = 'Bill Pay';
  else if (lPayment === 'AGNT') dataTooltip = 'Agent Settlement';

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ textAlign: 'center' }}>{cell.value}</div>
  );
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();

  const selectedElement = jobListContext.selectedElement as AllPaymentListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();

  const invSec = findSecurityTask(appContext, FmsSecTask.AcctInvoiceList);
  const gInvSec = findSecurityTask(appContext, FmsSecTask.AcctGInvoList);
  const billSec = findSecurityTask(appContext, FmsSecTask.AcctBillList);
  const gBillSec = findSecurityTask(appContext, FmsSecTask.AcctGBillList);
  const crdbSec = findSecurityTask(appContext, FmsSecTask.AcctCrDbList);

  function OpenNewPageAsync(link:string) {
    openNewPage(history, link, NavigationType.newPage);
    return Promise.resolve(true);
  }


  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    let viewUrl = '', editUrl = '';

    switch (selectedElement.type) {
      case 'M':
        viewUrl = `/accounting/acCCPayment/view/${id}`;
        editUrl = `/accounting/acCCPayment/edit/${id}`;
        break;
      case 'D':
        const isAgentPay = selectedElement.isAgentPay;
        viewUrl = isAgentPay ? `/accounting/acAgentPayment/view/${id}` : `/accounting/acCustomerPayment/view/${id}`;
        editUrl = isAgentPay ? `/accounting/acAgentPayment/edit/${id}` : `/accounting/acCustomerPayment/edit/${id}`;
        break;
      case 'C':
        viewUrl = `/accounting/acBillPayment/view/${id}`;
        editUrl = `/accounting/acBillPayment/edit/${id}`;
        break;
    }

    const urls = [viewUrl, editUrl];

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function moveToDeleteHistoryReport() {
    const listSec = findSecurityTask(appContext, FmsSecTask.AcctAllPayDeleteHistory);
    if (!listSec?.grantRead) {
      await showGlobalOkDialog(<p>Please check your user security!!!</p>);
      return;
    }

    // if (!selectedElement) {
    //   return;
    // }

    const id = selectedElement?.id ?? 0;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.AllPayment}&id=${id}`;

    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function switchToBillings(){
    if (!selectedElement || selectedElement.paymentType === "CC") {
      return;
    }
    let isExistId = false;
  
      const apiResult = await appContext.api.getRelatedBillingIds(selectedElement.id);
      if(apiResult && apiResult.result){
        const billingids = apiResult.result;     
        let model = new SearchModelBase();
  
        if(invSec.grantRead && billingids.RelateInvId && billingids.RelateInvId.length > 0){ 
            isExistId = true;
            model.extraWhere = `Id in (${billingids.RelateInvId})`;
            jobListContext.setFilterForScreenExternally('/common/joblistview/invoice/accounting?parentOp=billings',
            '','','Billings','',false,true,model);
            await OpenNewPageAsync('/common/joblistview/invoice/accounting?parentOp=billings');
        } 
  
        if(billSec.grantRead && billingids.RelateBillId && billingids.RelateBillId.length > 0){ 
          isExistId = true;
          model.extraWhere = `Id in (${billingids.RelateBillId})`;
          jobListContext.setFilterForScreenExternally('/common/joblistview/bill/accounting?parentOp=billings',
          '','','Billings','',false,true,model);
          await OpenNewPageAsync('/common/joblistview/bill/accounting?parentOp=billings');
        }
  
        if(crdbSec.grantRead && billingids.RelateCrDbId && billingids.RelateCrDbId.length > 0){ 
          isExistId = true;
          model.extraWhere = `Id in (${billingids.RelateCrDbId})`;
          jobListContext.setFilterForScreenExternally('/common/joblistview/crdb/accounting?parentOp=billings',
          '','','Billings','',false,true,model);
          await OpenNewPageAsync('/common/joblistview/crdb/accounting?parentOp=billings');
        }
        
        if(gInvSec.grantRead && billingids.RelateGInvId && billingids.RelateGInvId.length > 0){
          isExistId = true;
          model.extraWhere = `Id in (${billingids.RelateGInvId})`;
          jobListContext.setFilterForScreenExternally('/common/joblistview/acGeneralInvoice/accounting?parentOp=billings',
          '','','Billings','',false,true,model);
          await OpenNewPageAsync('/common/joblistview/acGeneralInvoice/accounting?parentOp=billings');
        }
  
        if(gBillSec.grantRead && billingids.RelateGBillId && billingids.RelateGBillId.length > 0){ 
          isExistId = true;
          model.extraWhere = `Id in (${billingids.RelateGBillId})`;
          jobListContext.setFilterForScreenExternally('/common/joblistview/acGeneralBill/accounting?parentOp=billings',
          '','','Billings','',false,true,model);
          await OpenNewPageAsync('/common/joblistview/acGeneralBill/accounting?parentOp=billings');
        }
      } 
      
      if(!isExistId){
        await showGlobalOkDialog("Can not go to Billings List.");
      }
  }

  return { view, moveToDeleteHistoryReport, switchToBillings };
}

function RightClickMenu({ dismiss }: { dismiss: VoidFunction }) {
  const { view, switchToBillings } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as AllPaymentListItem;
  // console.log(selectedElement);
  const items = [
    { label: 'View', shortcut: 'F9', separator: true },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to Billings List', shortcut:'F6', separator: false, hidden: selectedElement.paymentType === "CC" },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem name="allPayment-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        view();
        break;
      case 1:
        jobListContext.triggerTableSearch('F5');
        break;
      case 2:
        switchToBillings();
        break;
      case 3:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function TrancationImpactButtonCommands({ userId }: { userId: string }) {
  // const jobListContext = useContext(JobListViewContext);
  // const selectedElement = jobListContext.selectedElement as AllPaymentListItem;
  // const { switchJournal } = useJournal();
  // const appContext = useContext(ApplicationContext);
  // const paymentType = selectedElement?.type ?? '';
  // if (!getSecBySecTask(appContext, FmsSecTask.ListJournalPayment, SecType.Read) && !userId.startsWith('@')) {
  //   return null;
  // }

  // let jobName = JobNames.None;
  // switch (paymentType) {
  //   case 'M':
  //     jobName = JobNames.CCPayment;
  //     break;
  //   case 'D':
  //     jobName = selectedElement.isAgentPay ? JobNames.AgntPayment : JobNames.CustPayment;
  //     break;
  //   case 'C':
  //     jobName = JobNames.BillPayment;
  //     break;
  // }

  // return (
  //   <JournalIconButton onClick={() => switchJournal(jobName, selectedElement.id)} useText />
  // );
  return  null;
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const selectedElement = jobListContext.selectedElement as AllPaymentListItem;
  const paymentType = selectedElement?.type ?? '';

  const { view, moveToDeleteHistoryReport } = useSelectedOperations();
  const appContext = useContext(ApplicationContext);
  const { viewReport } = useReportViewer();
  const { switchJournal } = useJournal();

  const userId = appContext.user?.id ?? '';
  const checkSecJournal = !getSecBySecTask(appContext, FmsSecTask.ListJournalPayment, SecType.Read) && !userId.startsWith('@');

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function print() {
    if (!selectedElement) {
      return;
    }

    const title = `Deposit Slip [${selectedElement?.checkNo}]`;
    const args = new CheckSubArgs({
      docType: DocumentType.CheckSub,
      formCaption: title,
      subject: title,

      tbId: selectedElement?.id.toString() ?? '',
      tbName: "T_DEPOHD"
    });

    viewReport(args, "", true);
  }

  function switchJournalByJobName(){
      let jobName = JobNames.None;
      switch (paymentType) {
        case 'M':
          jobName = JobNames.CCPayment;
          break;
        case 'D':
          jobName = selectedElement.isAgentPay ? JobNames.AgntPayment : JobNames.CustPayment;
          break;
        case 'C':
          jobName = JobNames.BillPayment;
          break;
      }
      switchJournal(jobName, selectedElement.id);
  }

  async function customerBalance() {
    if (selectedElement.customerId <= 0) {
      await showGlobalOkDialog(<p>You didn't enter Customer.</p>, false, null, 'warning');
      return;
    }

    let jobName = JobNames.None;
    switch (selectedElement.type) {
      case 'M':
        jobName = JobNames.CCPayment;
        break;
      case 'D':
        jobName = selectedElement.isAgentPay ? JobNames.AgntPayment : JobNames.CustPayment;
        break;
      case 'C':
        jobName = JobNames.BillPayment;
        break;
    }

    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <CustomerBalanceDetails
          jobId={selectedElement.id}
          jobName={jobName}
          onPopupClose={onPopupClose}
          toDate={selectedElement.postDate??nowDate()}
          comId={selectedElement.customerId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.firstCustomer}
        />
    })
  }
  const hasSelectedRow = !!selectedElement;

  const hasSecBal = getSecBySecTask(appContext, FmsSecTask.ListBalance, SecType.Read);
  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}

      <ViewIconButton2 name='allPayment-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />

      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <ViewHistoryIconButton
          name='allPayment-list-history-button'
          disabled={!hasSelectedRow}
          onClick={() => {
            let jobType = '';
            switch (selectedElement.type) {
              case 'M':
                jobType = FmsSubMenu.MPHistory;
                break;
              case 'D':
                jobType = selectedElement.isAgentPay ? FmsSubMenu.APHistory : FmsSubMenu.CPHistory
                break;
              case 'C':
                jobType = FmsSubMenu.BPHistory;
                break;
            }
            setSelectedPopupMenuItem({ label: 'View History', popupWidth: 1240, popupComponent: <HistoryViewPayment jobId={selectedElement.id} jobType={jobType} /> })
          }}
          useText
        />
        <DeleteHistoryIconButton name='allPayment-list-deleteHistory-button' onClick={moveToDeleteHistoryReport} disabled={false} useText />
        {hasSecBal && (<BalanceIconButton name='allPayment-list-balance-button' disabled={!hasSelectedRow} onClick={customerBalance} useText />)}
      </div>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ? <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"} /> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
      <PrintIconButton name='billPayment-list-printCheck-button'
        onClick={() => {
          if (selectedElement.type === 'C') {
            if (selectedElement.void) {
              showGlobalOkDialog(<p>Void Payment can't print checks.</p>);
              return;
            }
            if (selectedElement.isDraft) {
              showGlobalOkDialog(<p>Draft Payment can't print checks.</p>);
              return;
            }
            const data = { id: selectedElement.id, bankId: selectedElement.bankId, checkNo: selectedElement.checkNo };
            setSelectedPopupMenuItem({ label: 'Print Check', popupWidth: 450, popupComponent: <CheckPrint checkRange={false} selectedElement={data} documentType={DocumentType.Check} batchCheck={false} /> });
          }
          else if (selectedElement.type === 'M') {
            showGlobalOkDialog(<p>Nothing to Print!</p>, false, null, 'warning');
          }
          else {
            print();
          }
        }}
        disabled={false}
        useText
      />
      </div>
      {!checkSecJournal && <JournalIconButton onClick={() => switchJournalByJobName()} useText />}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({ onFunction: onFunctionKey });

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, FmsSecTask.AcctAllPayment);
  const history = useHistory();

  const { view, switchToBillings } = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F6") {
      switchToBillings();
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F9', 'F11', 'F8', 'F6'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const selectedElement = jobListContext.selectedElement as AllPaymentListItem;
  const paymentType = selectedElement?.type ?? '';

  let jobName = JobNames.None;
  switch (paymentType) {
    case 'M':
      jobName = JobNames.CCPayment;
      break;
    case 'D':
      jobName = selectedElement.isAgentPay ? JobNames.AgntPayment : JobNames.CustPayment;
      break;
    case 'C':
      jobName = JobNames.BillPayment;
      break;
  }

  return (
    <InfoAreaDrawer
      //hideLogHistory={true}
      showContent={jobListContext.infoAreaContent}
      //entityName={constants.infoAreaEntity.otherShipmentMbl}
      jobName={jobName}
      //entityId={(jobListContext.selectedElement as AllPaymentListItem | null)?.id}
      jobId={selectedElement?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for All Payment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.AllPayment,
      'AllPaymentListItem',
      AllPaymentListItem.calculateSearchParameters(search, AllPaymentListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: AllPaymentListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  
  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.AllPayment, 'AllPaymentListItem',
      AllPaymentListItem.calculateSearchParameters(search, AllPaymentListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  AllPaymentListItem.formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    return [
      { accessor: 'status', Cell: IndicatorRenderer },
      { accessor: 'isDraft', Cell: NullableCheckboxIconRenderer },
      { accessor: 'block', Cell: NullableCheckboxIconRenderer },
      { accessor: 'paymentType', Cell: PaymentTypeRenderer },
      { accessor: 'void', Cell: VoidRenderer, Header: () => <div data-tooltip="Void">Void</div> },
      { accessor: 'customer', Cell: TextAlignLeftRenderer },
      { accessor: 'receivedFrom', Cell: TextAlignLeftRenderer },
      { accessor: 'payment', Cell: TypeRenderer },
      { accessor: 'checkNo', Cell: TextAlignLeftRenderer },
      { accessor: 'bank', Cell: TextAlignLeftRenderer },
      { accessor: 'currency', Cell: TextRenderer },
      { accessor: 'amount', Cell: (props: any) => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} /> },
      { accessor: 'chkPrint', Cell: TextRenderer },
      { accessor: 'invoiceNo', Cell: TextAlignLeftRenderer },
      { accessor: 'invBillCrdb', Cell: TextAlignLeftRenderer },
      { accessor: 'remark', Cell: TextAlignLeftRenderer },
      { accessor: 'u1ID', Cell: TextAlignLeftRenderer },
      { accessor: 'u2ID', Cell: TextAlignLeftRenderer },

      { accessor: 'postDate', Cell: DateRenderer },
      { accessor: 'depositDate', Cell: DateRenderer },
      // {accessor: 'voidDate', Cell: VoidDateRenderer},
      { accessor: 'u2Date', Cell: DateTimeRenderer },
      { accessor: 'u1Date', Cell: DateTimeRenderer },
    ];
  }

  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'isDraft', changedValue: (value: any) => { return nullableCheckBoxValue(value['isDraft']) } });
    colRenderer.push({ accessor: 'block', changedValue: (value: any) => { return nullableCheckBoxValue(value['block']) } });
    colRenderer.push({ accessor: 'void', changedValue: (value: any) => { return nullableCheckBoxValue(value['void']) } });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'postDate',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings = allPaymentList;
    const cols = AllPaymentListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands />
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar />
    );
  }

  renderExtras() {
    return <ListViewExtras />
  }

  getViewUrlFor(row: AllPaymentListItem) {
    const rowId = row.id;
    let viewUrl = '';
    
    switch (row.type) {
      case 'M':
        viewUrl = `/accounting/acCCPayment/view/${rowId}`;
        break;
      case 'D':
        viewUrl = row.isAgentPay ? `/accounting/acAgentPayment/view/${rowId}` : `/accounting/acCustomerPayment/view/${rowId}`;
        break;
      case 'C':
        viewUrl = `/accounting/acBillPayment/view/${rowId}`;
        break;
    }

    return viewUrl;
  }

  getListViewTitle() {
    return 'Payment List';
  };

  renderAdditionalCommands() {
    // All Payment List 구현 당시 CC/C/B/A payment List 4종 모두 showAdjustBalance가 false기 때문에 jobName을 신경쓰지 않음
    return <JobListSuntekCommand jobName={JobNames.AllPayment} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default ListView;
